<div class="login-layout d-flex justify-content-center min-vh-100 animated fadeIn" [class.neighborhood-background]="authLogo.loading">
    <div class="row flex-column w-100">
        <app-auth-logo #authLogo (loadedOrganization)="organizationUrl = $event"></app-auth-logo>

        <div *ngIf="!authLogo.loading" class="container full-width-cards animated fadeIn">
            <div [class.grid-layout]="!isForwarding" [class.grid-3-middle-fixed]="!isForwarding">
                <app-login-form class="auth-form d-flex w-100" [isForwarding]="isForwarding">
                    <h2>{{ 'Already have an account? Log in below.' }}</h2>
                </app-login-form>

                <ng-container *ngIf="!isForwarding">
                    <div class="card card-vertical-separator d-block d-md-none">
                        <span>{{ 'or' }}</span>
                    </div>
                    <div class="card card-horizontal-separator d-none d-md-flex">
                        <span>{{ 'or' }}</span>
                    </div>
                </ng-container>

                <app-auth-verify-email *ngIf="!isForwarding" class="auth-form d-flex w-100" [organizationUrl]="organizationUrl">
                    <h2>{{ 'Need to create your account?' }}</h2>
                    <p class="notification-bar mt-3">{{ 'Once approved by your community, you\'ll receive an email registration link.' }}</p>
                </app-auth-verify-email>
            </div>

            <app-auth-logo [type]="'footer'"></app-auth-logo>
        </div>
    </div>
</div>

